export const styles = {
  rtDiv: {
    backgroundColor: "red",
    display: "flex",
    height: 40,
    paddingLeft: 5,
    paddingRight: 5,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "0px 4px 0px 5px"
  },
  rtSpan: {
    color: "white",
    fontSize: 15,
    fontWeight: "bold",
    textShadow: "1px 0 black"
  }
};
